/* eslint-disable max-len */
import { handleApiRequest } from '../services/transports';
import { userModel } from '../constants';

import { REACT_APP_RSD_DOMAIN } from './base';

export const searchUsers = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/QueryUsers/user-manamgement-search`,
  method: 'get',
  query
});

export const mpViewProfile = () => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/UserActions/mp-view-profile`,
  method: 'get'
});


export const userHistory = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/QueryUsers/user-manamgement-history`,
  method: 'get',
  query
});

export const createPassword = (username, data) => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/UserActions/sop-reset-password/${username}`,
  method: 'post',
  data
});

export const resetPassword = data => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/UserActions/submit-recovery-password`,
  method: 'post',
  data
});
export const smpResetPassword = data => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/UserActions/submit-smp-recovery-password`,
  method: 'post',
  data
});

export const validatePasswordReset = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/UserActions/validate-password-reset`,
  method: 'get',
  query
});

export const sendResetPasswordEmail = UserName => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/UserActions/mp-reset-user-password/${UserName}`,
  method: 'post'
});

export const updateStatus = data => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/UserActions/mp-activate-deactivate-user/${data[userModel.USER_ACTIVATION.USERNAME]}`,
  method: 'put',
  data
});

export const newUser = data => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/Register/mp-umn-stakeholder-user`,
  method: 'post',
  data
});

export const editUser = data => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/Register/mp-ume-stakeholder-user`,
  method: 'put',
  data
});

export const getUserPrivileges = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/Utility/service-privileges-by-username`,
  method: 'get',
  query
});

export const updateProfile = data => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/UserActions/mp-update-profile`,
  method: 'put',
  data
});

export const searchBlacklistedUsers = data => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/UserActions/mp-view-blacklist`,
  method: 'put',
  data
});

export const addBlacklist = data => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/UserActions/mp-insert-blacklist`,
  method: 'put',
  data
});

export const removeBlacklist = data => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/UserActions/mp-delete-blacklist`,
  method: 'put',
  data
});

export const getBlacklistingUsersHistory = (gln, perPage, page) => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/UserActions/mp-view-blacklist-history?gln=${gln}&perPage=${perPage}&page=${page}`,
  method: 'get'
});

export const searchSubscribedListUsers = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/Subscription/ListSubscriptions`,
  method: 'get',
  query
});

export const subscriptionType = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/Subscription/types`,
  method: 'get',
  query
});

export const subscriptionPackage = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/Subscription/packages`,
  method: 'get',
  query
});


export const addSubscription = data => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/Subscription/AddSubscription`,
  method: 'post',
  data
});

export const getSubscribedListUsersHistory = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/Subscription/GetSubscriptionHistory`,
  method: 'get',
  query
});

export const extendSubscription = data => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/Subscription/ExtendStakeholderSubscription`,
  method: 'post',
  data
});

export const cancelSubscription = (id, subscriptionTypeId) => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/Subscription/cancel/${subscriptionTypeId}/${id}`,
  method: 'post'
});

export const subscriptionsReport = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/SubscriptionReports/GetSubscriptionsReport`,
  method: 'get',
  query
});

export const SubscriptionOperationReport = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/SubscriptionReports/GetSubscriptionsOperationsReport`,
  method: 'get',
  query
});

export const StockMatchOperationReport = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/SubscriptionReports/GetStockMatchOperationsReport`,
  method: 'get',
  query
});

export const StockMatchSubscriptionsOperationsReport = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/SubscriptionReports/GetStockMatchSubscriptionsOperationsReport`,
  method: 'get',
  query
});

export const UnregisteredDrugsSubscriptionsOperationsReport = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/SubscriptionReports/GetUnregisteredDrugSubscriptionsOperationsReport`,
  method: 'get',
  query
});

export const listSubscriptionTypes = () => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/SubscriptionReports/ListSubscriptionTypes`,
  method: 'get'
});

